import { QueryObserverOptions } from 'react-query';

import { makeResourceKeys } from 'requests/resources/makeResources/makeResourcesKeys';
import { useEntityById } from 'requests/resources/makeResources/queries';
import { Params } from 'requests/resources/makeResources/types';

import { PatientForm } from '../types';

export const userKeys = makeResourceKeys('patientForms');

export default function usePatientFormById(
  id: string,
  params: Params = {},
  options?: QueryObserverOptions<PatientForm>,
) {
  const query = useEntityById<PatientForm>(userKeys.entity, { id, ...params }, options);
  return query;
}
